<template>
  <div class="message-main">
    <a-card :bordered="false">
      <div v-if="isShowIndex">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="7" :lg="6" :md="8" :sm="24">
                <a-form-item label="任务标题">
                  <a-input
                    placeholder="请输入任务标题"
                    v-model="queryParam.title"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="10" :lg="12" :md="18" :sm="24">
                <a-form-item label="创建时间">
                  <a-range-picker
                    :placeholder="['开始时间', '结束时间']"
                    :value="createValue"
                    @change="handleChange"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [
                        moment('00:00:00', 'HH:mm:ss'),
                        moment('11:59:59', 'HH:mm:ss'),
                      ],
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="7" :lg="6" :md="8" :sm="24">
                <a-form-item label="审核状态">
                  <a-select
                    v-model="queryParam.taskStatus"
                    placeholder="请选择状态"
                  >
                    <a-select-option
                      v-for="(item, index) in taskList"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="7" :lg="6" :md="8" :sm="24">
                  <a-form-item label="发布状态">
                    <a-select
                      v-model="queryParam.jobsStatus"
                      placeholder="请选择状态"
                    >
                      <a-select-option
                        v-for="(item, index) in jobsList"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="10" :lg="12" :md="18" :sm="24">
                  <a-form-item label="审核时间">
                    <a-range-picker
                      @change="auditChange"
                      :value="auditValue"
                      :placeholder="['开始时间', '结束时间']"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [
                          moment('00:00:00', 'HH:mm:ss'),
                          moment('11:59:59', 'HH:mm:ss'),
                        ],
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="7" :lg="6" :md="8" :sm="24">
                  <a-form-item label="审核人">
                    <a-input
                      placeholder="请输入审核人"
                      v-model="queryParam.auditUser"
                    ></a-input>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span
                  style="float: left; overflow: hidden"
                  class="table-page-search-submitButtons"
                >
                  <a-button type="primary" @click="searchQuery" icon="search"
                    >查询</a-button
                  >
                  <a-button
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                    >重置</a-button
                  >
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="messageImport()" type="primary" icon="upload"
            >导入</a-button
          >
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"
                ><a-icon type="delete" />批量删除</a-menu-item
              >
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作 <a-icon type="down"
            /></a-button>
          </a-dropdown>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
            >项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <!-- <span slot="mgTkResults" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ text }}</a>
        </span> -->
            <span slot="mgTkResults" slot-scope="text, record">
              <span v-if="text">
                <a @click="importFail(record)">{{
                  text ? text[0].failNumber : '-'
                }}</a>
                <span>/</span>
                <a @click="importSucceed(record)">{{
                  text ? text[0].successNumber : '-'
                }}</a>
                <span>/</span>
                <a @click="importTotal(record)">{{
                  text ? text[0].totalNumber : '-'
                }}</a>
              </span>
              <a v-else>
                {{ '-' }}
              </a>
            </span>
            <span slot="action" slot-scope="text, record">
              <a
                @click="handleAudit(record)"
                v-if="record.taskStatus == 0 || record.taskStatus == 2"
                >审核</a
              >
              <a-divider
                type="vertical"
                v-if="record.taskStatus == 0 || record.taskStatus == 2"
              />
              <a
                @click="handleEdit(record)"
                v-if="record.taskStatus == 0 || record.taskStatus == 2"
                >编辑</a
              >
              <a @click="handleLook(record)" v-if="record.taskStatus == 1"
                >查看</a
              >
              <a-divider
                type="vertical"
                v-if="record.taskStatus == 0 || record.taskStatus == 2"
              />
              <a
                @click="handleDelete(record.id)"
                v-if="record.taskStatus == 0 || record.taskStatus == 2"
                >删除</a
              >
            </span>
          </a-table>
        </div>
      </div>
    </a-card>
    <message-import-modal
      v-if="isImport"
      ref="modalForm"
      @handelColse="handelColse"
      @ok="modalFormOk"
    ></message-import-modal>
    <message-task-modal ref="editModal" @ok="editModalOk"></message-task-modal>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import MessageImportModal from './modules/messageImport.vue';
import MessageTaskModal from './modules/messageTaskModal.vue';
import { filterObj } from '@/utils/util';
import customRender from '@/utils/customRender.js';
import { postTag } from '@/api/manage';
import moment from 'moment';

export default {
  name: 'MessageTaskList',
  components: {
    JDate,
    MessageImportModal,
    MessageTaskModal,
  },
  data() {
    return {
      jobsList: [
        {
          name: '未发送',
          value: 0,
        },
        {
          name: '发送中',
          value: 2,
        },
        {
          name: '已发送',
          value: 4,
        },
      ],
      taskList: [
        {
          name: '未审核',
          value: 0,
        },
        {
          name: '已审核',
          value: 1,
        },
        {
          name: '已驳回',
          value: 2,
        },
      ],
      isShowIndex: true,
      isImport: false,
      loading: false,
      selectedRowKeys: [],
      toggleSearchStatus: false,
      selectionRows: [],
      dataSource: [], //table数据
      auditValue: [],
      createValue: [],
      queryParam: {
        //查询数据
        title: '',
        auditUser: '',
        createStartTime: '',
        createEndTime: '',
        auditStartTime: '',
        auditEndTime: '',
        taskStatus: '',
        jobsStatus: '',
      },
      endTime: [], //审核时间
      startTime: [], //创建时间
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '任务标题',
          align: 'center',
          dataIndex: 'title',
          // ellipsis: true,
          customRender: customRender,
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'taskStatus',
          customRender: (text) => {
            if (text == 0) {
              return '未审核';
            } else if (text == 1) {
              return '已审核';
            } else if (text == 2) {
              return '已驳回';
            }
          },
        },
        {
          title: '发送状态',
          align: 'center',
          dataIndex: 'jobsStatus',
          customRender: (text) => {
            if (text == 0) {
              return '未发送';
            } else if (text == 2) {
              return '发送中';
            } else if (text == 4) {
              return '已发送';
            }
          },
        },
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'auditUser',
          customRender: customRender,
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'auditTime',
          customRender: customRender,
        },
        {
          title: '失败/成功/全部',
          align: 'center',
          dataIndex: 'mgTkResults',
          scopedSlots: { customRender: 'mgTkResults' },
          // ellipsis: true,
          // customRender: customRender,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/page',
        delete: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/delete',
        deleteBatch: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/batchDelete',
      },
      dictOptions: {},
      superFieldList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    moment,
    // 跳转到消息明细界面  失败
    importFail(record) {
      console.log(record);
      this.$router.push({
        path: '/messageCenter/messageDetail/index',
        query: { id: record.id, status: 0, title: record.title },
      });
    },
    // 跳转到消息明细界面  成功
    importSucceed(record) {
      console.log(record);
      this.$router.push({
        path: '/messageCenter/messageDetail/index',
        query: { id: record.id, status: 1, title: record.title },
      });
    },
    // 跳转到消息明细界面  全部
    importTotal(record) {
      console.log(record);
      this.$router.push({
        path: '/messageCenter/messageDetail/index',
        query: { id: record.id, title: record.title },
      });
    },
    // 审核
    handleAudit(record) {
      console.log(record);
      this.$refs.editModal.add(record);
      this.$refs.editModal.auditList = record;
      this.$refs.editModal.getList();
      this.$refs.editModal.title = '审核';
    },
    editModalOk() {
      this.getList(1);
    },
    // 查看
    handleLook(record) {
      this.$refs.editModal.add(record);
      this.$refs.editModal.auditList = record;
      this.$refs.editModal.getList();
      this.$refs.editModal.title = '查看';
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.isShowIndex = !this.isShowIndex;
      this.isImport = !this.isImport;
      setTimeout(() => {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.importList = record;
      });
    },
    // 导入
    messageImport() {
      this.isShowIndex = !this.isShowIndex;
      this.isImport = !this.isImport;
    },
    modalFormOk() {
      this.isShowIndex = !this.isShowIndex;
      this.isImport = !this.isImport;
      this.getList(1);
    },
    handelColse() {
      this.isShowIndex = !this.isShowIndex;
      this.isImport = !this.isImport;
    },
    initDictConfig() {},
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.selectionRows, '>>>>');
    },
    // 获取数据
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      postTag(that.url.list, params)
        .then((res) => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //获取查询条件
    getQueryParams() {
      let param = Object.assign(this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function () {
          that.loading = true;
          postTag(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList(1);
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      let isHasReview = this.selectionRows.some((item) => {
        return item.checkStatus == 1;
      });
      if (isHasReview) {
        this.$message.warning('已审核的数据不能删除');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = [];
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids.push(this.selectedRowKeys[a]);
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postTag(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.createValue = [];
      this.auditValue = [];
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    //获取创建时间
    handleChange(date, dateStrings) {
      this.createValue = date;
      let startTime = dateStrings[0];
      let endTime = dateStrings[1];
      if (startTime == '' || endTime == '') {
        this.queryParam.createStartTime = '';
        this.queryParam.createEndTime = '';
      } else {
        this.queryParam.createStartTime = startTime;
        this.queryParam.createEndTime = endTime;
      }
    },
    //获取结息时间
    auditChange(date, dateStr) {
      this.auditValue = date;
      let startTime = dateStr[0];
      let endTime = dateStr[1];
      if (startTime == '' || endTime == '') {
        this.queryParam.auditStartTime = '';
        this.queryParam.auditEndTime = '';
      } else {
        this.queryParam.auditStartTime = startTime;
        this.queryParam.auditEndTime = endTime;
      }
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
.delBtn {
  border: none;
  background-color: #ffffff;
}
.message-main {
  height: 100%;
}
</style>
